import React, { PureComponent } from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import * as api from '../../requests/loader';
import { playFullMedia } from '../../actions/playmedia';
import store from './../../store';
import LayersControl from '../../utils/LayersControl';
import FlagTimeOut from '../../AAF/TimeoutAAF/FlagTimeOut';
import './styles/modalEndPlayer2.scss';
import { ColoredButton } from '../../packages/components/lib/ColoredButton/';
import { Grid, Column, Row, cls } from '../../packages/components';
import Translator from '../../requests/apa/Translator';
import UtilsPagos from "../../utils/payway/UtilsPagos";
import Utils, {getContentCategory, getContentAvailability, getSeasonEpisodeInfo} from '../../utils/Utils';
import { getAndroidTvPolicesLabels, getAddonAndroidMessageClassNames } from '../../payments/utils/Utils';
import Button from '../Button';
import { MODAL_END_PLAYER2, MODAL_PIN, HIDE_MODAL, showModal, MODAL_CHANGING_EPISODE } from '../../actions/modal';
import { MODAL_PIN_CODE_PURCHASE_TYPE } from '../Modal/ModalPinCode';
import EventEmitter from '../../utils/EventEmitter';
import AnalyticsDimensionSingleton from '../../components/Header/AnalyticsDimensionSingleton';
import { setMetricsEvent } from '../../actions/metrics';
import Device from '../../devices/device';
import Metadata from '../../requests/apa/Metadata';
import {GA4} from '../../utils/trackers/GA4';
import {CONTENT_SECTION_END_PLAYER, DOES_NOT_APPLY}  from '../../utils/trackers/GA4Constants';
import { setValuesStoreModalKeepWatching } from 'src/components/Modal/functions/ModalKeepWatching/functions';
import AAF from '../../AAF/AAF';
import ExperienceHourRefresh from '../../AAF/Ads/AdsTimer'
import { AdsUtils } from '../../AAF/Ads/Utils';
import Constans from '../../AAF/Ads/Constans';
import AAFPlayer from '../../AAFPlayer/AAFPlayer';

const subs_in_end_player = 'in-end-player';
class ModalEndPlayer2 extends PureComponent {
  constructor(props) {
    super(props);
    this.dataNext = {};

    this.playNextEpisodeWhenEndPlayerClosed = props.playNextEpisodeWhenEndPlayerClosed;
    this.calculateNext = this.calculateNext.bind(this);
    this.updateTimer = this.updateTimer.bind(this);
    this.playNextContent = this.playNextContent.bind(this);
    this.yellowButton = this.yellowButton.bind(this);
    this.play = this.play.bind(this);
    this.resetEndPlayer = this.resetEndPlayer.bind(this);
    this.getDelayFinPlayer = this.getDelayFinPlayer.bind(this);
    this.PBIEpisodeNext = props.PBIEpisodeNext;
    this.updateTimerIntervalId = null;
    const asset = props.asset || false;
    const content = props.content || false;
    let buttons = [];
    const buttonsAlign = props.buttonsAlign || 'horizontal';
    this.next = props.next;
    const contentDuration = props.duration
    const currentTime = props.currentTime
    let device = Device.getDevice().getPlatform();
    const device_subplatform = Device.getDevice().getSubplatform();
    if(Utils.isNotNullOrNotUndefined(device_subplatform) && device === 'android') {
      device = device_subplatform;
    }
    const safeTimeData = Metadata.get('end_player_safetime', '{ "default": { "safetime": 0 }, "androidtv": { "safetime": 10 }, "ps4": { "safetime": 10 },  "stbcoship": { "safetime": 10 } }');
    const objectSafeTime = JSON.parse(safeTimeData)
    const safeTime = objectSafeTime[device] === undefined ? objectSafeTime['default'] : objectSafeTime[device];
    const isSerie = this.next ? true : false;
    const diffTime = this.getDelayFinPlayer(contentDuration,currentTime,isSerie)
    if(diffTime <= 2 ){
      this.updateTimer();
    }

    //Default Time 10 segundos
    this.timerInitialTime = !isNaN(diffTime) ? diffTime : 10;
    this.state = {
      visible: false,
      purchaseButtons: [],
      pbiNext: [],
    };
    this.timerTime = this.timerInitialTime;

    this.calculateNext(this.next, this.PBIEpisodeNext);

    if (props.buttons) {
      const tmp = props.buttons.map(button => {
        const newButton = Object.assign({}, button);
        const cb = newButton.props.onClick;
        newButton.props.onClick = e => {
          props.handleClose(e, cb);
        };
        return newButton;
      });
      buttons = [...buttons, ...tmp];
    }

    this.titleBack = Translator.get('title_close_modal_episodes', 'CERRAR');

    this.p = {
      buttonsAlign,
      buttons,
      yellowButton: this.yellowButton,
      childrenClassName: 'modal_full_height_options_endplayer2',
      callbackWhenBack: () => {
       this.resetEndPlayer();
      }
    };

    if (asset) this.p['asset'] = asset;
    if (content) this.p['content'] = content;
    this.userType = AAF.AdsUtils.getUserType();
  }

  /**
   * data rolls from redux before update with next episode
   * @returns postroll data
   */
  getBeforeRolls()  {
    const { ID_POST_ROLL_BITMOVIN_SERVICE } = Constans;
    const { rolls } = store.getState().ads;
    const rollsBefore = rolls;
    return rollsBefore[ID_POST_ROLL_BITMOVIN_SERVICE];
  }

  activeCountdown = async() => {
    const isExperienceActive = AdsUtils.isAdsEnable();
    const showPostRoll =  this.getAfterRolls() === "true"  && await this.getBeforeRolls()  === "false";
    AAFPlayer.setCancelPostRoll(!showPostRoll);
    return isExperienceActive && showPostRoll;
  };
  /**
   * data rolls from redux after update with next episode
   * @returns preroll data
   */
  getAfterRolls = async() => {
    const { ID_PRE_ROLL_BITMOVIN_SERVICE } = Constans;
    const { rolls: rollsAfter } = store.getState().ads;
    await AdsUtils.updateStoreAutoChangeEpisode(this.next.id, this.PBIEpisodeNext.playButton.payway_token);
    return rollsAfter[ID_PRE_ROLL_BITMOVIN_SERVICE];
  }

  async updateTimer() {
    let activeUpdateTimer = false;
    const validateInitTimerForPublicity = this.timerTime === this.timerInitialTime &&
    this.refs.playNextContentTimer && AdsUtils.isAdsEnable();

    if(validateInitTimerForPublicity) {
      activeUpdateTimer = await this.activeCountdown();
    }
    if (this.timerTime === 1 ) {
      clearTimeout(this.updateTimerIntervalId);
      !activeUpdateTimer && this.playNextContent();
    } else {
      if(this.refs.playNextContentTimer){
        this.timerTime--;
        this.refs.playNextContentTimer.innerHTML = this.displayTime();
      }
    }
  }

  yellowButton(e) {
    //Se realiza la funcion del boton cerrar.
    this.props.handleClose(e);
  }

  getDelayFinPlayer(contentDuration,currentTime,isSerie){
    let delayFinPlayer = 0;
    const remainderTimePlayer = parseInt(contentDuration - currentTime);
    if(isSerie) {
      delayFinPlayer = Utils.getDelayFinPlayerSeries();
      if(remainderTimePlayer < delayFinPlayer) {
        if( remainderTimePlayer <= 2) {
          this.timerTime = remainderTimePlayer;
          return remainderTimePlayer;
        }
        delayFinPlayer = parseInt(remainderTimePlayer);
      }
    }else{
      delayFinPlayer = parseInt(contentDuration - currentTime);
    }
    return delayFinPlayer
  }

  async forcedPlayNextContent(){
    this.state = {
      visible: true,
      purchaseButtons: [],
      pbiNext: [],
    };
    store.dispatch(showModal({modalType: MODAL_CHANGING_EPISODE}))
  }

  componentWillUnmount() {
    if(this.timerTime === 0){
      clearInterval(this.updateTimerIntervalId);
    }
  }

  addClassToParent = () => {
    const x = document.getElementById('modal-overlay-main');
    if (x && x.classList && typeof x.classList.add === 'function') {
      x.classList.add('modal-overlay-endpayer2');
    }
  };

  componentDidMount() {
    this.addClassToParent();
    const statusUser = store.getState().user.userStatus;
    statusUser === "anonymous" && setValuesStoreModalKeepWatching({nextGroupId:this.next.id})
  }

  displayTime(){
    return `${this.timerTime} ${Translator.get('playing_finplayer_secondToStart_label', 'segundos')}`;
  }

  async calculateNext(next, PBIEpisodeNext) {
    // Si es serie
    if (next) {
      this.setUpdateTimer();
      FlagTimeOut.setIsFromSerie(true);
      this.purchaseNextEpisode(next.id, PBIEpisodeNext);
      this.dataNextSerieEpisode(next);
    }
    // Es movie o episodio final de serie
    else {
      // Si es movie y se debe poner de recomendados
      const {recommendations = false, history: {location: {pathname=''} = {}}={}} = this.props || {};
      let endPlayerRecommendations = []
      if (Array.isArray(recommendations) && recommendations.length>0){
        endPlayerRecommendations = recommendations;
      }
      else{
        let [,,groupId=false] = pathname.split("/")
        const [,nav = null] = pathname.split("/");
        groupId = nav !== null ? this.props && this.props.idCardSrach : groupId;
        if (groupId){
          endPlayerRecommendations = await api.contentRecomendations({groupId, is_only_provider: true});
        }
        else {
          return
        }
      }
      if (Array.isArray(endPlayerRecommendations) && endPlayerRecommendations.length > 0) {
        // Se toma el primer recomendado
        const recomendado = endPlayerRecommendations[0];
        const result = await api.PurchaseButtonInfov585({ groupId: recomendado.id });

        this.dataNext = {
          provider: recomendado.proveedor_code,
          episodeNumber: null,
          description: recomendado.description,
          imgSrc: recomendado.image_still,
          seasonNumber: null,
          title: recomendado.title,
          gid: recomendado.id
        };

        // Es visible play?
        if (JSON.parse(result.playButton.visible)) {
          this.setState({
            visible: true,
            pbiNext: result
          }, () => {
            if (JSON.parse(result.playButton.visible)) {
              window.SpatialNavigation.focus('.aaf-main-modal-endplayer2-button-play');
            }
          });
        }
        else {
          const purchaseButtons = this.getPurchaseBtns(result, recomendado.id);
          this.setState({
            purchaseButtons,
            visible: false,
            pbiNext: result
          }, () => {
            window.SpatialNavigation.focus('.purchase1');
          }
          );
        }
      }
    }
  }

  dataNextSerieEpisode(next) {
    this.dataNext = {
      episodeNumber: next.extendedcommon.media.episode.number,
      description: next.description,
      imgSrc: next.image_still,
      seasonNumber: next.extendedcommon.media.episode.season,
      title: next.title,
      gid: next.id,
      provider: next.proveedor_code,
    };
  }

  setUpdateTimer = async() => {
    this.updateTimerIntervalId = setInterval(await this.updateTimer, 1000);
  };

  changeInfoPlayButtonToAdsMultiPbi(multiPbi, groupId) {
    const { listButtons = {} } = multiPbi || {}
    const dataButtons = listButtons[groupId] ? listButtons[groupId] : {}
    const { playFreemiumButton = {}} = dataButtons || {}

    if (playFreemiumButton && playFreemiumButton.visible === "1") {
      dataButtons.playButton = playFreemiumButton
    }

    return {
      ...multiPbi,
      listButtons:{
        [groupId]: dataButtons
      }
    }

  }

  async purchaseNextEpisode(groupId, PBIEpisodeNext) {
    const result = await PBIEpisodeNext;

    if (JSON.parse(result.playButton.visible)) {
      this.setState({
        visible: true,
        pbiNext: result
      }, () => {
        if (JSON.parse(result.playButton.visible)) {
          window.SpatialNavigation.focus('.aaf-main-modal-endplayer2-button-play');
        }
      });
    }
    // Se toman los botones de purchase, porque ya no se puede ver
    else {
      const purchaseButtons = this.getPurchaseBtns(result, groupId);
      this.setState({
        purchaseButtons,
        visible: false,
        pbiNext: result
      }, () => {
        window.SpatialNavigation.focus('.purchase1');
      }
      );
    }
  }

  getAddonAndroidMessage(){
    const classes = {
        classNameContainer: `aaf-main-modal-endplayer2-container-android-tv-policies`,
        classNameTitle: 'title-android-tv',
        classNameDescription: 'description-android-tv'
    };

    return getAddonAndroidMessageClassNames(getAndroidTvPolicesLabels(), classes);
}

  isFreemiumLogged(){
    const FAL = AAF.AdsUtils.isFreemiumLogged(this.userType);
    const continueAfterLogin = store.getState().ads && store.getState().ads.continueAfterLogin

    return FAL && continueAfterLogin ? true : false;
  }

  getPurchaseBtns(purchaseButtonInfo, groupId) {
    const purchaseButtonsVisible = this.isPurchaseButtonsVisible(purchaseButtonInfo);

    if (UtilsPagos.shouldShowAndroidMessage(purchaseButtonsVisible)) {
      const getAddonAndroidMessage = this.getAddonAndroidMessage();
      return ([
        <div className='aaf-main-modal-endplayer2-wrapper-android-tv-policies'>
          {getAddonAndroidMessage}
        </div>])
    }

    let ct = 1;
    const purchaseButtons = purchaseButtonsVisible
      ? purchaseButtonInfo.listButtons.button
        .map((btn, index) => {
            const sendGA4Metric = (selectedButton) => {
            const gA4 = new GA4();
            const { price, producttype, recommendations } = selectedButton || {};
            const isSerie = this.next ? true : false;
            if (isSerie) {
              const isEpisode = producttype.includes('EPISODE');
              const { next } = this;
              const { id: groupId, title, extendedcommon: { media: { serie: { title: serieTitle } = {}, islive, proveedor: { codigo: provider, nombre: providerName } = {}, episode } = {}, genres: { genre } = {}, format: { types } = {} } = {} } = next;
              const isLive = islive === '1';
              const episodeInfo = { name: title, ...episode };
              const name = isEpisode ? title : serieTitle;
              const genders = genre.map((g) => g.desc);
              const category = getContentCategory(isLive, isSerie, genders);
              const category2 = genders && Array.isArray(genders) ? genders.join(' ') : DOES_NOT_APPLY;
              const category3 = getContentAvailability(types, provider, isSerie, isEpisode, producttype);
              const category4 = getSeasonEpisodeInfo(isSerie, isEpisode, episodeInfo);

              gA4.sendStartCheckoutEvent(groupId, name, category, category2, category3, category4, providerName, CONTENT_SECTION_END_PLAYER, price, 1);
            } else {
              const [firstRecommendation,] = recommendations || [];
              if (firstRecommendation) {
                const { id: groupId, title: name, live_enabled, proveedor_code: provider, proveedor_name: providerName, format_types } = firstRecommendation;
                const isLive = live_enabled === '1', isSerie = false, isEpisode = false;
                const category = getContentCategory(isLive, isSerie, []);
                const category2 = DOES_NOT_APPLY;
                const category3 = getContentAvailability(format_types, provider, isSerie, isEpisode, producttype);
                const category4 = getSeasonEpisodeInfo(isSerie, isEpisode, {});

                gA4.sendStartCheckoutEvent(groupId, name, category, category2, category3, category4, providerName, CONTENT_SECTION_END_PLAYER, price, 1);

              }
            }
          }
          const goToPayment = (currentPin = null) => {
            btn.accessCode = purchaseButtonInfo.accessCode;
            btn.fromVCard = false;
            btn.accessCodePin = currentPin;
            btn.recommendations = this.props.recommendations ? this.props.recommendations : [];
            btn.provider = this.dataNext.provider;
            sendGA4Metric(btn);
            setValuesStoreModalKeepWatching({comeThisModal:true, groupId});
            if (this.props.user.isLoggedIn || this.isFreemiumLogged() || AAF.AdsUtils.isUserFreemium(this.userType)) {
              // Se cambia direccionamiento a nuevo componente Checkout
              const { params: { group_id } } = Utils.getRequest(btn.linkworkflowstart);
              const urlFlowType = this.props.history.location.pathname;
              this.props.history.push(`/detailtransaction`, { groupId: group_id || groupId, ...btn, urlFlowType, forceReset: false });
            } else {
              this.props.history.push(`/landing`, btn);
            }
          };

          const getApaConfiguration = key => {

            const local_purchasebutton_colors = {
              default: {
                gradient: {
                  direction: 'to right',
                  color_stop1: '#FF9900 0%',
                  color_stop2: '#FFd400 100%',
                  background: '#FF9900'
                }
              }
            };

            const returnValue = Utils.getApaMetadataKey('purchasebutton_colors', local_purchasebutton_colors, key);

            if (returnValue) {
              return returnValue;
            }

            const defaultReturnValue = Utils.getApaMetadataKey('purchasebutton_colors', local_purchasebutton_colors, 'default');
            return defaultReturnValue;

          };

          const getButtonStyle = btn => {
            const key = `${btn.producttype}_wp${btn.waspurchased}`;
            const buttonColors = getApaConfiguration(key);
            const background = 'none';
            let style = {};

            if (buttonColors) {
              if (buttonColors.gradient) {
                let directionWebkit = '';
                switch (buttonColors.gradient.direction) {
                  case 'to left':
                    directionWebkit = 'right';
                    break;
                  case 'to right':
                  default:
                    directionWebkit = 'left';
                    break;
                }
                style = {
                  background: `-webkit-linear-gradient(${directionWebkit}, ${buttonColors.gradient.color_stop1}, ${buttonColors.gradient.color_stop2})`,
                  'background-image': `linear-gradient(${buttonColors.gradient.direction}, ${buttonColors.gradient.color_stop1}, ${buttonColors.gradient.color_stop2})`
                };
              } else if (buttonColors.background) {
                style.background = `${buttonColors.background}`;
              }
            }
            return style;
          };

          const style = getButtonStyle(btn);
          const order = ['left-text', 'right-text'];

          const currencyAndPriceBtn = btn.currency && btn.price ? ` ${btn.currency}${btn.price}` : null;

          return btn.waspurchased !== '1' ? (
            <div key={index} className="purchase-btn-container">
              <Button
                rightText={currencyAndPriceBtn}
                leftText={`${(Translator.get(btn.oneofferdesckey, '').replace('@frequency', btn.frequency)).toUpperCase()}`}
                order={order}
                className={`purchase${ct++} purchase large elementopredeterminado ${btn.producttype} aaf-main-modal-endplayer2-button-purchase`}
                style={style}
                onClick={() => {
                  this.stop();
                  this.props.closeModal({
                    type: HIDE_MODAL,
                    modalType: MODAL_END_PLAYER2
                  });

                  this.updateTimerIntervalId && clearInterval(this.updateTimerIntervalId);
                  /**
                   * TODO revisar send metrics
                   */
                  this.sendMetricPBI(btn);
                  if (
                    purchaseButtonInfo &&
                    purchaseButtonInfo.accessCode &&
                    purchaseButtonInfo.accessCode.enabled
                  ) {
                    const modal = {
                      modalType: MODAL_PIN,
                      modalProps: {
                        type: MODAL_PIN_CODE_PURCHASE_TYPE,
                        action: 'MP_CHECAR_STATUS',
                        pinIsCreated: true,
                        successCallBack: (currentPin, pinIsCreated) => {
                          this.closeModal(pinIsCreated);
                          goToPayment(currentPin);
                        },
                        flag: true
                      }
                    };
                    store.dispatch(showModal(modal));
                  } else {
                    goToPayment();
                  }
                }}
                onFocus={e => { }}
              />
            </div>
          ) : null;
        })
        .filter(btn => btn !== null)
      : null;

    const showPurchaseButtons = Array.isArray(purchaseButtons) && purchaseButtons.length > 0;

    return showPurchaseButtons ? purchaseButtons : [];
  }

  closeModal(pinIsCreated) {
    if (pinIsCreated) {
      this.props.closeModal({
        type: HIDE_MODAL,
        modalType: MODAL_END_PLAYER2
      });
    }
  }

  play = (gid, isReplay = false,) => {
    if (ExperienceHourRefresh.getIsPlaying()) {
      this.stop();
      return;
    }
    let title = '';
    let languageoptions = null;
    const isSerie = this.next ? true : false;
    if(isSerie) {
      title = `${this.dataNext.seasonNumber}-${this.props.serieTitle}/${this.dataNext.episodeNumber}-${this.dataNext.title}`;
      const { extendedcommon: { media: { language: { options: { option }  = {} } = {} } = {} } } = this.next;
      if(Utils.isNotNullOrNotUndefined(option) && Array.isArray(option)) {
        languageoptions = option;
      }
    }
    else {
      title = this.dataNext.title;
    }
    this.sendMetric('ver ahora', title);
    const pbi = this.state.pbiNext;
    const paywayToken = this.props.PBIEpisodeNext !== null ? (this.props.PBIEpisodeNext && this.props.PBIEpisodeNext.playButton && this.props.PBIEpisodeNext.playButton.payway_token ):  (pbi && pbi.playButton && pbi.playButton.payway_token);

    const nextgid = {
      ispip: false,
      islive: false,
      ispreview: false,
      payway_token: paywayToken,
      resume: 0,
      source: {
        videoid: gid
      },
      playerstate: 'PLAYING',
      event: null
    };

    if(Utils.isNotNullOrNotUndefined(languageoptions)) {
      nextgid.languageoptions = languageoptions;
    }

    if (isReplay) {
      nextgid.isReplay = isReplay;
    }

    if (this.recommendations) {
      Object.assign(nextgid, { recommendations: this.recommendations });
    }
    this.props.handleClose(null);
    if(isSerie){
      const changingEpisodaData = {
        seasonNumber: this.dataNext.seasonNumber,
        episodeNumber: this.dataNext.episodeNumber,
        episodeTitle:this.dataNext.title,
        serieTitle:  this.props.serieTitle,
      }
      store.dispatch(showModal({modalType: MODAL_CHANGING_EPISODE, modalProps: changingEpisodaData}))
    }
    store.dispatch(playFullMedia(nextgid));
  };

  async playNextContent() {
    this.updateTimerIntervalId && clearInterval(this.updateTimerIntervalId);
    // Es serie
    if (this.next) {
      const { next } = this.props;
      const pbi = this.PBIEpisodeNext;
      // this.stop();
      const wasPurchased = pbi && pbi.playButton && pbi.playButton.waspurchased;
      if (wasPurchased) {
        // Nos movemos a la siguiente ficha de sig episodio
        this.play(next.id);
        EventEmitter.emit('player:episodeChange', { groupId: next.id });
        // setTimeout(this.play, 100, next.id, true);
      }
    }
    // Es movie o lo que sea que se pueda reproducir, y vamos a la ficha en el background
    else {
      // this.stop();
      /**
       * Si intento no hacer lo de abajo, el bind no jala :/
       * por eso se hace así that=this-style :/
       */
      const play = this.play;
      const gid = this.dataNext.gid;
      this.recommendations = await api.contentRecomendations({groupId:gid, is_only_provider: true});
      setTimeout(() => {
        EventEmitter.emit('player:episodeChange', { groupId: gid });
        play(gid);
      }, 100);
    }
  }

  stop = () => {
    if (LayersControl.isPlayerVisible()) {
      LayersControl.hidePlayer(true);
    }
    const nullPlayer = {
      ispip: false,
      islive: false,
      ispreview: false,
      playerstate: 'STOPPING',
      event: null
    };
    store.dispatch(playFullMedia(nullPlayer));
  };

  handleBack = () => {
    this.sendMetric('click', 'cerrar');
    this.resetEndPlayer();
    this.props && (typeof this.props.handleClose === 'function') && this.props.handleClose();
  };

  resetEndPlayer() {
    this.updateTimerIntervalId && clearInterval(this.updateTimerIntervalId);

    if(this.playNextEpisodeWhenEndPlayerClosed) {
      let dataNextEpisode = null;
      if(this.next) {
        dataNextEpisode = {...{serieTitle: this.props.serieTitle}, ...this.next};
        if(this.recommendations) {
          dataNextEpisode.recommendations = this.recommendations;
        }
      }
      this.playNextEpisodeWhenEndPlayerClosed(dataNextEpisode, this.PBIEpisodeNext);
    }

    document.dispatchEvent(
      new CustomEvent('handlesubtitlesscreenposition', {
        detail: { isShowed: false, className: subs_in_end_player }
      })
    );
  }

  capitalizeFirst = (str) => {
    if (typeof str !== 'string') return '';

    return str.charAt(0).toUpperCase() + str.slice(1)
  }

  isPurchaseButtonsVisible(purchaseButtonInfo) {
    return (
      purchaseButtonInfo &&
      purchaseButtonInfo.listButtons &&
      purchaseButtonInfo.listButtons.button
    );
  }

  sendDimension() {
    const payload = new AnalyticsDimensionSingleton().getPayload();
    store.dispatch(setMetricsEvent(payload));
    store.dispatch(setMetricsEvent({ type: 'executor' }));
  }

  sendMetric(action, label) {
    if (typeof setMetricsEvent === 'function') {
      store.dispatch(
        setMetricsEvent({
          hitType: 'event',
          eventCategory: 'fin player',
          eventAction: action,
          eventLabel: label
        })
      );
      store.dispatch(setMetricsEvent({ type: 'executor' }));
      this.sendDimension();
    }
  }

  sendMetricPBI(btn) {
    let label = '';
    const isSerie = this.next ? true : false;
    if(isSerie) {
      label = `${this.dataNext.seasonNumber}-${this.props.serieTitle}/${this.dataNext.episodeNumber}-${this.dataNext.title}`;
    }
    else {
      if(this.props.recommendations && this.props.recommendations[0]) {
        label = this.props.recommendations[0].title;
      }
    }

    let action = '';
    const { oneoffertype = '', producttype, oneofferdesc } = btn;
    if (oneoffertype.toLowerCase().includes('buy')) {
        if (producttype.toLowerCase().includes('season')) {
          action = 'temporada completa';
        } else if (producttype.toLowerCase().includes('episode')) {
          action = 'episodio';
        } else {
          action = 'compra';
        }
    } else if (oneoffertype.toLowerCase().includes('rent')) {

      if (oneofferdesc.toLowerCase().includes('48')) {
        action = 'renta 48 horas';
      } else if (oneofferdesc.toLowerCase().includes('24')) {
        action = 'renta 24 horas';
      } else {
        action = 'renta 24 horas';
      }
    }
    else if (oneoffertype.toLowerCase().includes('subscrition')) {
      action = 'suscripcion';
    }

    this.sendMetric(action, label);
  }

  resizeImage = (url) => {
    let urlNew = '';
    urlNew = `${url}?size&imwidth=254`;

    return urlNew;
  }

  render() {
    const isSerie = this.next ? true : false;
    const serieTitle = this.props.serieTitle ? Utils.cutFinPlayerString(this.props.serieTitle, 55, 52) : null;
    const porqueVisteTitle = isSerie ? Translator.get('playing_finplayer_finalizeSeasonRecommended_label', 'También podría gustarte:') : Translator.get('playing_finplayer_movieRecommended_label', 'También podría gustarte:');
    const contentTitle = Utils.cutFinPlayerString(this.dataNext.title, 55, 52);
    const imageSrc = this.resizeImage(this.dataNext.imgSrc);
    const contentDescription =  Utils.cutFinPlayerString(this.dataNext.description, 128, 125);
    const seasonNumber = this.dataNext.seasonNumber;
    const episodeNumber = this.dataNext.episodeNumber;

    return (
      <ModalWrapper {...this.p}>
        <Grid className={cls(`aaf-main-modal-options-endplayer2`)}>
          <Row className={cls(`aaf-main-modal-endplayer2-wrapper`)}>
            <Column lg="3" className={cls('aaf-main-modal-endplayer2-imageWrapper')}>
            {this.dataNext && this.dataNext.imgSrc && <img src={imageSrc} className={cls('aaf-main-modal-endplayer2-image')} alt='img_still' />}
            </Column>
            <Column lg="6" className={cls('aaf-main-modal-endplayer2-resumeWrapper')}>
              {
                isSerie
                  ?
                  <div className={cls('aaf-main-modal-endplayer2-contentTitleSerie')}>
                    {serieTitle}
                  </div>
                  :
                  <div className={cls('aaf-main-modal-endplayer2-porqueVisteTitle')}>
                    {porqueVisteTitle}
                  </div>
              }
              {
                isSerie ?
                  <div className={cls('aaf-main-modal-endplayer2-contentSeason')}>
                    {Translator.get('playing_finplayer_abbreviationSeason_label', 'Temp.')} {seasonNumber} | {Translator.get('playing_finplayer_abbreviationEpisode_label', 'Ep.')} {episodeNumber} : <span className={cls('aaf-main-modal-endplayer2-emphasis')}> {contentTitle} </span>
                  </div>
                  :
                  <div className={cls('aaf-main-modal-endplayer2-contentTitle')}>
                    {contentTitle}
                  </div>
              }
              <div className={cls('aaf-main-modal-endplayer2-contentDescription')}>
                {contentDescription}
              </div>
            </Column>
            <Column lg="3" className={cls('aaf-main-modal-endplayer2-buttonWrapper')}>
              {
                isSerie && this.state.visible ?
                  <div className={cls('aaf-main-modal-endplayer2-timerWrapper')}>
                    {
                    this.capitalizeFirst(Translator.get('playing_finplayer_toStart_label', 'Comienza en'))}: <span className=
                    {cls('aaf-main-modal-endplayer2-emphasis')} ref='playNextContentTimer'>{this.displayTime()}</span>
                  </div>
                  :
                  null
              }

              <div className={this.state.visible ?
                  cls('aaf-main-modal-endplayer2-buttonsWrapper', (isSerie ? 'aaf-main-modal-endplayer2-buttonsWrapper-playb-serie' : 'aaf-main-modal-endplayer2-buttonsWrapper-playb')) :
                  cls('aaf-main-modal-endplayer2-buttonsWrapper')}>
                {
                  this.state.visible
                    ?
                    <Button
                      type="button"
                      className={cls('aaf_button aaf_button-dark focusable aaf-main-modal-endplayer2-button-play')}
                      onClick={this.playNextContent}
                      text={Translator.get('playing_finplayer_option_button _playFromNow', 'Ver ahora')}
                    >
                    </Button>
                    :
                    <div className={cls('aaf-main-modal-endplayer2-purchaseButtonsWrapper-purchase', (this.state.purchaseButtons.length === 1 ? '' : (isSerie ? 'aaf-main-modal-endplayer2-purchaseButtonsWrapper-purchase-2-serie' : 'aaf-main-modal-endplayer2-purchaseButtonsWrapper-purchase-2')) )}>
                      {
                        this.state.purchaseButtons.length > 0
                        &&
                        this.state.purchaseButtons.map((btn) => {
                          return btn;
                        })
                      }
                    </div>
                }
              </div>

            </Column>
          </Row>
          <Row>
            <Column className={cls('aaf-main-modal-endplayer2-wraper-blue-div')}>
              <ColoredButton color="blue" className={cls(`aaf-main-modal-endplayer2-blue-button`, `focusable`)} onClick={this.handleBack}>{this.titleBack}</ColoredButton>
            </Column>
          </Row>
        </Grid>
      </ModalWrapper>
    );
  }
}

export default withOnClose(ModalEndPlayer2);



// WEBPACK FOOTER //
// ./src/components/Modal/ModalEndPlayer2.jsx